import React from "react";
import { ChevronDown } from "lucide-react";

const PartnerSelect = ({
  id,
  name,
  value,
  onChange,
  options,
  placeholder,
  required = false,
  disabled = false,
  className = "",
}) => (
  <div className="relative">
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      className={`w-full partner-input partner-select rounded-lg px-4 py-2.5 pr-10 text-sm font-body appearance-none cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed ${
        !value ? "text-partner-muted" : ""
      } ${className}`}
    >
      <option value="" disabled className="bg-[#11151F] text-partner-muted">
        {placeholder}
      </option>
      {options.map((opt) => {
        const optValue = typeof opt === "string" ? opt : opt.value;
        const optLabel = typeof opt === "string" ? opt : opt.label;
        return (
          <option key={optValue} value={optValue} className="bg-[#11151F] text-partner">
            {optLabel}
          </option>
        );
      })}
    </select>
    <ChevronDown
      className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-partner-accent/70 pointer-events-none"
      aria-hidden
    />
  </div>
);

export default PartnerSelect;
